import { render, staticRenderFns } from "./FederationGroupsTableModal.vue?vue&type=template&id=9979a426&"
import script from "./FederationGroupsTableModal.vue?vue&type=script&lang=js&"
export * from "./FederationGroupsTableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports